module.exports = __webpack_public_path__ + "static/media/img_homepage_logo-NA.e9f4bf1a.png";